import { Types } from "@grandvisionhq/graphql";
import { enumValueToString } from "@grandvisionhq/utils";
const filterAppointmentTypes = (appointmentTypes, appointmentTypeFilters) => {
  const filterAvailableStores = ({
    isAvailableInStore
  }) => isAvailableInStore;
  const filterTryInStore = (shouldFilter) => {
    return ({ tryInStore }) => {
      return shouldFilter ? tryInStore === true : tryInStore === false;
    };
  };
  const tryInStoreFilter = appointmentTypeFilters?.find((filter) => "tryInStore" in filter);
  const filterGroupId = (groupId) => {
    return ({
      groupId: appointmentTypeGroupId
    }) => {
      if (!groupId || groupId === null) return true;
      return appointmentTypeGroupId === groupId;
    };
  };
  const groupIdFilter = appointmentTypeFilters?.find((filter) => "groupId" in filter);
  return appointmentTypes.filter(filterAvailableStores).filter(filterGroupId(groupIdFilter?.groupId ?? null)).filter(filterTryInStore(!!tryInStoreFilter?.tryInStore));
};
const mapAppointmentTypes = (appointmentTypes, appointmentTypeFilters) => {
  const filteredAppointmentTypes = filterAppointmentTypes(appointmentTypes, appointmentTypeFilters);
  return filteredAppointmentTypes.map(
    ({ id, name, description, duration, price, ageGroup, visibleToCustomers }) => ({
      id,
      name,
      description: description ?? "",
      duration: {
        amount: duration.amount ?? 0,
        unit: duration.unit ?? "MINUTES"
      },
      price: price ?? void 0,
      ageGroup: enumValueToString(Types.AppointmentTypeAgeGroup, ageGroup),
      isVisibleToCustomers: visibleToCustomers
    })
  );
};
const fromStoreByIdQueryToStore = (storeQueryData, appointmentTypeFilters) => {
  if (!storeQueryData) {
    return null;
  }
  try {
    const {
      code,
      globalStoreId,
      name,
      shortName,
      email,
      streetName,
      streetNumber,
      additionalStreetInfo,
      postalCode,
      town,
      province,
      country,
      lat,
      lon,
      phone,
      slug,
      appointmentTypes,
      appointmentsAvailable,
      servicesNotAvailable
    } = storeQueryData;
    const isAppointmentsServiceNotAvailable = servicesNotAvailable?.includes(Types.ServicesNotAvailable.APPOINTMENTS) ?? false;
    if (isAppointmentsServiceNotAvailable) {
      console.warn(
        `Appointment service is not available for store with globalStoreId: ${globalStoreId}.`
      );
      return null;
    }
    return {
      code,
      globalStoreId,
      name,
      shortName,
      streetName,
      town,
      country,
      phone,
      slug: slug ?? void 0,
      streetNumber: streetNumber ?? void 0,
      additionalStreetInfo: additionalStreetInfo ?? void 0,
      postalCode: postalCode ?? void 0,
      province: province ?? void 0,
      lat: lat ?? void 0,
      lon: lon ?? void 0,
      emailAddress: email ?? void 0,
      appointmentTypes: mapAppointmentTypes(appointmentTypes, appointmentTypeFilters),
      appointmentsAvailable,
      servicesNotAvailable: servicesNotAvailable ?? []
    };
  } catch (e) {
    console.error(
      "Store query data adapter failed to parse input data correctly.",
      e,
      storeQueryData
    );
    return null;
  }
};
export {
  fromStoreByIdQueryToStore
};
//# sourceMappingURL=from-store-by-id-query-to-store.js.map
